var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7072 0.99585L14.4143 1.70296L23.0001 10.2887L23.7072 10.9958L23.7031 10.9999L23.7072 11.004L23.0001 11.7111L14.4143 20.2969L13.7072 21.004L12.293 19.5898L13.0001 18.8826L19.8789 12.0038L1.29297 12.0038H0.292969V10.0038H1.29297L19.8867 10.0038L13.0001 3.11717L12.293 2.41006L13.7072 0.99585Z",
    fill: "#242938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1ce42f45035dd701cfba67c5ebb46125.svg";
export { ForwardRef as ReactComponent };